<template>
  <router-view />
</template>

<script>
export default {
  name: 'edit'
}
</script>


// WEBPACK FOOTER //
// Edit.vue?7e2fb994